import createLocalContext from '@helpers/utils/local-context';
import { CTAProductContextInterface } from './interfaces';

export const [useCtaProductContext, CTAProductContext] = createLocalContext<CTAProductContextInterface>();
